import Swal from 'sweetalert2';

const defaults = {
    buttonsStyling: false,
    customClass: {
        actions: 'd-flex justify-content-between flex-nowrap',
        cancelButton: 'btn btn-gray w-100 mr-4',
        confirmButton: 'btn btn-primary w-100',
        denyButton: 'btn btn-gray w-100 mr-4',
    },
    padding: '2rem',
    reverseButtons: true,
};

export class SweetAlert2Wrapper {
    constructor() {
        this.validTypes = ['success', 'error', 'warning', 'info', 'question'];
    }

    validate(params) {
        // Check required
        this.required.forEach((key) => {
            if (!params[key])
                throw `Property '${key}' missing from ${this.constructor.name}, ${this.errorHelper()}`;
            if (typeof params[key] !== 'string')
                throw `${this.constructor.name} property '${key}' sent as ${typeof params[key]}, must be string`;
            if (params[key].trim() === '')
                throw `Cannot set ${this.constructor.name} property of '${key}' to an empty string!`;
        });
        // Check types/invalid/extras
        Object.keys(params).filter((key) => {
            if (!this.allowed.includes(key))
                throw `Invalid parameter sent in: '${key}', ${this.errorHelper()}`;
            if (key === 'type' && !!params[key]) {
                if (!this.validTypes.includes(params[key]))
                    throw `Unknown type for ${this.constructor.name}! Expected 'success', 'error', 'warning', 'info' or 'question', got '${params[key]}'`;
            }
        });
        return params;
    }

    errorHelper() {
        return `${this.constructor.name} only accepts: ${this.allowed.map((prop) => `'${prop}'`).join(', ')} and requires ${this.required.map((prop) => `'${prop}'`).join(', ')}`;
    }

    setTextAsHTML() {
        this.config.html = this.config.text;
        delete this.config.text;
    }

    show() {
        return Swal.fire(Object.assign({}, defaults, this.config));
    }
}
